import { EPassengerCategory } from '../../common/types';

export const MAXIMUM_NUMBER_OF_MONTHS_IN_THE_FUTURE = 18;
export const FOCUS_NEXT_INPUT_DELAY = 100;
export const OVERLAY_ANIMATION_DURATION = 350;

export const DATE_TIME_SELECTOR_MIN_TIME = 6;
export const DATE_TIME_SELECTOR_MAX_TIME = 22;
export const DATE_TIME_SELECTOR_GAP = 2;

export const YOUNG_PASSENGER_MAX_AGE = 27;
export const YOUNG_PASSENGER_MIN_AGE = 0;

export const TSB_DEPARTURE_CITY_INPUT_TEST_ID =
  'travelSearchBarDepartureCityInput';
export const TSB_DESTINATION_CITY_INPUT_TEST_ID =
  'travelSearchBarArrivalCityInput';
export const TSB_SWITCH_CITIES_BUTTON_TEST_ID =
  'travelSearchBarSwitchCitiesButtonn';
export const TSB_ORIGIN_CITIES_PANEL_TEST_ID =
  'travelSearchBarOriginCitiesPanel';
export const TSB_DESTINATION_CITIES_PANEL_TEST_ID =
  'travelSearchBarDestinationCitiesPanel';
export const TSB_POPULAR_CITIES_TEST_ID = 'travelSearchBarPopularCities';
export const TSB_SUGGESTED_CITIES_TEST_ID = 'travelSearchBarSuggestedCities';
export const TSB_CITY_TEST_ID = 'travelSearchBarCity';
export const TSB_DEPARTURE_DATE_INPUT_TEST_ID =
  'travelSearchBarDepartureDateInput';
export const TSB_RETURN_DATE_INPUT_TEST_ID = 'travelSearchBarReturnDateInput';
export const TSB_DEPARTURE_DATE_PANEL_TEST_ID =
  'travelSearchBarDepartureDatePanel';
export const TSB_RETURN_DATE_PANEL_TEST_ID = 'travelSearchBarReturnDatePanel';
export const TSB_DATE_TIME_SELECTOR_TEST_ID = 'travelSearchBarDateTimeSelector';
export const TSB_REMOVE_RETURN_DATE_BUTTON_TEST_ID =
  'travelSearchBarRemoveReturnDateButtonn';
export const TSB_PASSENGERS_INPUT_TEST_ID = 'travelSearchBarPassengersInput';
export const TSB_PASSENGERS_PANEL_TEST_ID = 'travelSearchBarPassengersPanel';

export const TSB_ADD_PASSENGER_BUTTON_TEST_ID: Record<
  EPassengerCategory,
  string
> = {
  [EPassengerCategory.ADULT]: 'travelSearchBarAddAdultPassengerButton',
  [EPassengerCategory.SENIOR]: 'travelSearchBarAddSeniorPassengerButton',
  [EPassengerCategory.YOUNG]: 'travelSearchBarAddYoungPassengerButton',
};

export const TSB_REMOVE_PASSENGER_BUTTON_TEST_ID: Record<
  EPassengerCategory,
  string
> = {
  [EPassengerCategory.ADULT]: 'travelSearchBarRemoveAdultPassengerButton',
  [EPassengerCategory.SENIOR]: 'travelSearchBarRemoveSeniorPassengerButton',
  [EPassengerCategory.YOUNG]: 'travelSearchBarRemoveYoungPassengerButton',
};

export const TSB_UPDATE_PASSENGER_DISCOUNT_CARD_BUTTON_TEST_ID: Record<
  EPassengerCategory,
  string
> = {
  [EPassengerCategory.ADULT]: 'travelSearchBarUpdateAdultDiscountCardButton',
  [EPassengerCategory.SENIOR]: 'travelSearchBarUpdateSeniorDiscountCardButton',
  [EPassengerCategory.YOUNG]: 'travelSearchBarUpdateYoungDiscountCardButton',
};
export const TSB_UPDATE_PASSENGER_AGE_SELECTOR_TEST_ID =
  'travelSearchBarUpdatePassengerAgeSelector';
export const TSB_DISCOUNT_CARD_PANEL_TEST_ID =
  'travelSearchBarDiscountCardPanel';
export const TSB_DISCOUNT_CARD_TEST_ID = 'travelSearchBarDiscountCard';
export const TSB_SUBMIT_BUTTON_TEST_ID = 'travelSearchBarSubmitButton';
